const mediaItems = [
  {
    title: '《星际迷途》终极预告',
    desc: '浩瀚星际，人类命运悬于一线，年度科幻巨制震撼来袭。',
    img: 'https://readdy.ai/api/search-image?query=Epic%20cinematic%20space%20battle%20scene%20with%20dramatic%20orange%20and%20crimson%20nebula%20explosions%2C%20massive%20starships%20in%20combat%2C%20intense%20action%20atmosphere%2C%20movie%20trailer%20aesthetic%2C%20no%20text%20no%20faces%20no%20logos&width=800&height=450&seq=media-01-trailer&orientation=landscape',
    alt: '星际迷途终极预告',
  },
  {
    title: '《暗夜追踪》先导片花',
    desc: '迷雾孤岛上的连环迷案，真相在黑暗中悄然浮现。',
    img: 'https://readdy.ai/api/search-image?query=Mysterious%20foggy%20coastal%20cliff%20scene%20at%20dusk%20with%20a%20lone%20lighthouse%20beam%20cutting%20through%20darkness%2C%20atmospheric%20thriller%20mood%2C%20deep%20shadows%20and%20warm%20amber%20light%2C%20no%20text%20no%20faces%20no%20logos&width=800&height=450&seq=media-02-preview&orientation=landscape',
    alt: '暗夜追踪先导片花',
  },
  {
    title: '《热血拳台》幕后特辑',
    desc: '揭秘热血运动励志大片的拍摄幕后，真实训练铸就拳台传奇。',
    img: 'https://readdy.ai/api/search-image?query=Dramatic%20empty%20boxing%20gym%20with%20warm%20overhead%20lighting%20and%20dust%20motes%20floating%20in%20light%20beams%2C%20vintage%20fight%20posters%20on%20walls%2C%20atmospheric%20sports%20cinematography%2C%20no%20text%20no%20faces%20no%20logos&width=800&height=450&seq=media-03-bts&orientation=landscape',
    alt: '热血拳台幕后特辑',
  },
];

export default function MediaSection() {
  return (
    <section id="media" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-2xl md:text-3xl lg:text-4xl font-heading text-foreground-900 mb-3">
            精彩预告
          </h2>
          <p className="text-foreground-500 text-sm md:text-base max-w-xl mx-auto">
            最新电影预告与花絮，抢先感受大片魅力
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {mediaItems.map((item, i) => (
            <div
              key={i}
              className="group rounded-xl overflow-hidden bg-background-50 border border-background-200/70 cursor-pointer transition-all duration-300 hover:border-primary-200"
            >
              <div className="relative h-52 overflow-hidden">
                <img
                  src={item.img}
                  alt={item.alt}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  onError={(e) => {
                    (e.target as HTMLElement).style.display = 'none';
                  }}
                />
                <div className="absolute inset-0 flex items-center justify-center">
                  <div className="w-14 h-14 md:w-16 md:h-16 rounded-full bg-white/20 backdrop-blur-sm flex items-center justify-center group-hover:bg-primary-500/80 transition-colors">
                    <i className="ri-play-fill text-white text-2xl md:text-3xl ml-1"></i>
                  </div>
                </div>
                <div className="absolute bottom-3 right-3 bg-black/60 text-white text-xs px-2 py-0.5 rounded whitespace-nowrap">
                  预告片
                </div>
              </div>
              <div className="p-4">
                <h3 className="text-sm md:text-base font-heading text-foreground-900 mb-1.5 group-hover:text-primary-600 transition-colors">
                  {item.title}
                </h3>
                <p className="text-foreground-500 text-xs leading-relaxed">
                  {item.desc}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}